export class RequestOurCatalogue {
    public static Init(): void {
        new RequestOurCatalogue();
    }

    constructor() {
        this.MapLoqateFields("Address");

    }

    private MapLoqateFields(fieldPrefix: string): void {
        let options = {
            key: "TT89-AM94-RX42-YM69",
            suppressAutocomplete: false,
        };
        let fields = [
            { element: fieldPrefix + "_Company", field: "Company", mode: pca.fieldMode.DEFAULT },
            { element: fieldPrefix + "_AddressLine1", field: "Line1" },
            { element: fieldPrefix + "_AddressLine2", field: "Line2", mode: pca.fieldMode.POPULATE },
            { element: fieldPrefix + "_District", field: "Line3", mode: pca.fieldMode.POPULATE },
            { element: fieldPrefix + "_Town", field: "City", mode: pca.fieldMode.POPULATE },
            { element: fieldPrefix + "_County", field: "Province", mode: pca.fieldMode.POPULATE },
            { element: fieldPrefix + "_PostalCode", field: "PostalCode" },
            { element: fieldPrefix + "_CountryCode3", field: "CountryName", mode: pca.fieldMode.COUNTRY }
        ];
        new pca.Address(fields, options);
    }
}

if (document.body.dataset.pageInit == "catalogue") {
    RequestOurCatalogue.Init();
}
